
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trending",
      function () {
        return require("private-next-pages/trending.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trending"])
      });
    }
  